import * as angular from 'angular';

import { WizardRouteViewComponent } from './wizard-route-view/wizard-route-view.component';
import { courseEditorModule } from 'go-modules/course-editor';
import { feedbackSessionModule } from 'go-modules/feedback-session';
import { ngxLicenseManagementModule } from '@go-modules/components/license-management';
import { groupDepModel } from 'go-modules/models/group-dep';
import { groupsIndexModule } from 'go-modules/groups-index';
import { groupServiceModule } from 'go-modules/services/group';
import { ngxLicenseSeatsManagementModule } from '@go-modules/components/license-seats-management';
import { ngxUserSettingsModule } from '@go-modules/components/user-settings';
import { ngxFolderViewModule } from '@go-modules/components/folder-view';
// This will need to change to ngx/go-modules
import { ngxFoldersViewModule } from '@dashboard/app/components/folders-view';
import { ngxActivityViewModule } from '@go-modules/components/activity-view';
import { ngxActivityTaskSessionsModule } from '@go-modules/components/activity-task-sessions';
import { ngxTaskReportModule } from '@go-modules/components/task-report';
import { ngxActivityReportWrapperModule } from '@go-modules/components/activity-report-wrapper';
import { activityReportPanelModule } from 'go-modules/activity-report-panel';
import { groupCreatorModule } from 'go-modules/group-creator';
import { ngxSessionViewModule } from '@go-modules/components/feedback-session/session-view';
import { ngxTermsServiceModule } from '@go-modules/services/terms';
import { ngxQuickStartGuideModule } from '@lti/app/wizards/quick-start-guide';

export const routeViewsModule = angular
	.module('app.routeViews', [
		courseEditorModule,
		feedbackSessionModule,
		ngxLicenseManagementModule,
		ngxLicenseSeatsManagementModule,
		ngxUserSettingsModule,
		ngxFolderViewModule,
		ngxFoldersViewModule,
		ngxActivityViewModule,
		ngxActivityTaskSessionsModule,
		ngxTaskReportModule,
		ngxActivityReportWrapperModule,
		ngxSessionViewModule,
		feedbackSessionModule,
		activityReportPanelModule.name,
		groupCreatorModule,
		groupsIndexModule,
		groupDepModel,
		groupServiceModule,
		ngxTermsServiceModule,
		ngxQuickStartGuideModule
	])
	.component('wizardRouteView', WizardRouteViewComponent)
	.name;
